module.exports = __webpack_public_path__ + "img/128x128_carrier.bcc852d4.svg";